import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { makeStyles } from '@material-ui/core/styles';

import OutlinedButton from 'components/atoms/OutlinedButton';

import DisplayTpList from './DisplayTpList';

const displayFliterStyles = makeStyles((theme) => ({
  // 커스텀 스크롤바 사용시 꼭 필요한 CSS End
  buttonWrap: {
    '& > .mb-product-code-button': { marginLeft: 8, marginBottom: 5 },
  },
  subBtn: { fontSize: 14 },
}));

const DisplayPrdtList = (props) => {
  const {
    byTargeting = false,
    advrtsPrdtCode,
    advrtsTpCode,
    displayFilterList = null,
    params,
    useDisplayAll,
    handleProductClick,
    handleSubmit,
    handleTpClick,
  } = props;

  const { t } = useTranslation();
  const classes = displayFliterStyles();
  const { productCodeList, allProductCodeList } = useSelector(({ common }) => ({
    productCodeList: common.productCodeList,
    allProductCodeList: common.allProductCodeList,
  }));

  const [productCode, setProductCode] = useState(
    !!advrtsPrdtCode
      ? advrtsPrdtCode
      : !!params.advrtsPrdtCode
      ? params.advrtsPrdtCode
      : '00'
  );

  useEffect(() => {
    if (advrtsTpCode === false) {
      setProductCode('00');
    }
  }, [advrtsTpCode]);

  useEffect(() => {
    if (!!productCode && !!advrtsPrdtCode) {
      if (productCode !== advrtsPrdtCode) {
        setProductCode(advrtsPrdtCode);
      }
    }
    // eslint-disable-next-line
  }, [advrtsPrdtCode, params.advrtsPrdtCode]);

  return (
    <div>
      <div className={classes.buttonWrap}>
        {!byTargeting &&
          (() => {
            let result = [];
            if (useDisplayAll) {
              result = [
                <OutlinedButton
                  className={`mb-product-code-button ${classes.subBtn}`}
                  key="00"
                  onClick={(e) => handleProductClick('00')}
                  selected={productCode === '00'}
                  noneBorder
                >
                  {t('총합계')}
                </OutlinedButton>,
              ];
            }

            for (let data of productCodeList.values()) {
              const { label, value } = data;
              // 페이지별 디스플레이 필터 리스트 셋팅값이 없거나 있으면 세팅된 값만 보여줌
              if (
                displayFilterList === null ||
                (typeof displayFilterList[value] !== 'undefined' &&
                  typeof displayFilterList[value] === 'object')
              ) {
                result.push(
                  <OutlinedButton
                    className={`mb-product-code-button ${classes.subBtn}`}
                    key={label}
                    onClick={(e) => handleProductClick(value)}
                    selected={productCode === value}
                    noneBorder
                  >
                    {label}
                  </OutlinedButton>
                );
              }
            }
            return result;
          })()}
      </div>
      {byTargeting ? (
        <DisplayTpList
          list={allProductCodeList.values()}
          advrtsPrdtCode={advrtsPrdtCode}
          advrtsTpCode={advrtsTpCode}
          displayFilterList={displayFilterList}
          handleSubmit={handleSubmit}
          handleTpClick={handleTpClick}
        />
      ) : (
        productCode !== '00' &&
        typeof productCodeList.get(productCode) !== 'undefined' && (
          <DisplayTpList
            list={productCodeList.get(productCode).item}
            advrtsPrdtCode={advrtsPrdtCode}
            advrtsTpCode={advrtsTpCode}
            displayFilterList={displayFilterList}
            handleSubmit={handleSubmit}
            handleTpClick={handleTpClick}
            isTargetingState={productCode}
          />
        )
      )}
    </div>
  );
};

export default DisplayPrdtList;
